import {
  NumberInput,
  NumberInputField,
  NumberInputProps,
  Input,
} from "@chakra-ui/react";
import React from "react";
import { BaseFieldProps, FieldWrapper } from "../FieldWrapper/FieldWrapper";

interface IntegerFieldProps extends BaseFieldProps {}

const parseValue = (value: string) => {
  const parsed = value.replace(/[\$,]/g, "");

  if (parsed === "") {
    return "";
  }

  return parsed;
};

export const IntegerField = ({
  name,
  label,
  id,
  helperText,
  infoText,
  isRequired,
  precision = 0,
  ...numberInputProps
}: IntegerFieldProps & NumberInputProps) => {
  return (
    <FieldWrapper
      name={name}
      id={id}
      label={label}
      helperText={helperText}
      infoText={infoText}
      isRequired={isRequired}
    >
      {({ field, form }) => {
        // Format the value to show the correct number of decimal places
        const formatValue = (value: any) => {
          if (value === null || value === undefined || value === "") {
            return "";
          }
          const numValue =
            typeof value === "string" ? parseFloat(value) : value;
          if (typeof numValue === "number" && !isNaN(numValue)) {
            return numValue.toFixed(precision);
          }
          return value;
        };

        // Initialize display value with formatted field value - ONLY on mount
        const [displayValue, setDisplayValue] = React.useState(() =>
          formatValue(field.value)
        );

        return (
          <Input
            type="text"
            value={displayValue}
            onChange={(e) => {
              // Just update what's shown - don't format!
              const strValue = e.target.value;
              setDisplayValue(strValue);
              form.setFieldValue(field.name, parseValue(strValue), false);
            }}
            onBlur={(e) => {
              // Format ONLY on blur
              const formatted = formatValue(field.value);
              setDisplayValue(formatted);
              field.onBlur(e);
            }}
            name={field.name}
            id={id}
            placeholder={numberInputProps.placeholder}
            backgroundColor="#fff"
          />
        );
      }}
    </FieldWrapper>
  );
};
